import { Form, Input, Switch } from "antd";
import React, { useEffect, useState } from "react";
import {
  GetTagListApi,
  AddUpdateTagApi,
  DeleteTagApi,
  UpdateTagStatusApi,
} from "../../../api/request/setting/tag";
import moment from "moment";
import toast from "react-hot-toast";
import Add from "../../../assets/Add";
import SkeletonTable from "../../../components/table/SkeletonTable";
import columns from "../../../columns/setting/tags";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";
import GlobalTooltip from "../../../components/common/GlobalTooltip";

export default function Tags() {
  const [form] = Form.useForm();
  const initialTagValues = { name: "" };
  const [isAddEditTagModalOpen, setIsAddEditTagModalOpen] = useState(false);
  const [isAddEditTagLoading, setIsAddEditTagLoading] = useState(false);
  const [isEditTag, setIsEditTag] = useState(false);
  const [isTagDelete, setIsTagDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [selectedTag, setSelectedTag] = useState("");
  const [tags, setTags] = useState([]);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [isStatusLoading, setIsStatusLoading] = useState(false);

  const getTagList = async () => {
    setIsLoading(true);
    try {
      const { data } = await GetTagListApi({ type: "client" });
      if (data.status) {
        setTags(
          data?.data?.map((item) => {
            return {
              ...item,
              status: (
                <Switch
                  checked={item?.status == "active" ? true : false}
                  onClick={() => handleTagStatus(item)}
                  checkedChildren="On"
                  unCheckedChildren="Off"
                />
              ),
              created_at: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "--",
              action: (
                <div className="flex items-center gap-3">
                  <GlobalTooltip title={"Edit Tag"}>
                    <button onClick={() => handleEditModal(item)}>
                      <img
                        src="/assets/icons/edit.svg"
                        className="size-4"
                        alt="icon"
                      />
                    </button>
                  </GlobalTooltip>
                  <GlobalTooltip title={"Delete Tag"}>
                    <button
                      onClick={() => {
                        setSelectedTag(item);
                        setIsTagDelete(true);
                      }}
                    >
                      <img
                        src="/assets/icons/delete.svg"
                        className="size-4"
                        alt="icon"
                      />
                    </button>
                  </GlobalTooltip>
                </div>
              ),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTagList();
    setIsEditTag(false);
  }, []);

  const handleEditModal = (tag) => {
    setIsAddEditTagModalOpen(true);
    setIsEditTag(true);
    setSelectedTag(tag);
    form.setFieldsValue({ name: tag?.name });
  };

  const handleAddEditTag = async (values) => {
    try {
      setIsAddEditTagLoading(true);
      const params = isEditTag
        ? { ...values, id: selectedTag?.id, type: "client" }
        : { ...values, type: "client" };
      const { data } = await AddUpdateTagApi(params);
      if (data?.status) {
        setIsAddEditTagModalOpen(false);
        getTagList();
        form.resetFields();
        toast.success(data?.message);
      }
      setIsAddEditTagLoading(false);
      setIsEditTag(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsAddEditTagLoading(false);
      setIsEditTag(false);
    }
  };

  const handleTagStatus = (tag) => {
    setSelectedTag(tag);
    setIsStatusModalOpen(true);
  };

  const handleStatuChange = async () => {
    try {
      setIsStatusLoading(true);
      let params = {
        id: selectedTag?.id,
        status: selectedTag?.status === "active" ? "inactive" : "active",
      };
      const { data } = await UpdateTagStatusApi(params);
      if (data?.status) {
        toast.success(data?.message);
        getTagList();
        setIsStatusModalOpen(false);
      }
      setIsStatusLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsStatusLoading(false);
    }
  };

  const handleDeleteTag = async () => {
    setIsLoadingDelete(true);
    try {
      const { data } = await DeleteTagApi({ id: selectedTag?.id });
      if (data?.status) {
        setIsTagDelete(false);
        getTagList();
        toast.success(data?.message);
      }
      setIsLoadingDelete(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsLoadingDelete(false);
    }
  };

  useEffect(() => {
    if (!isAddEditTagModalOpen) {
      form.resetFields();
    }
  }, [isAddEditTagModalOpen]);

  return (
    <div>
      <div className="border rounded-xl pb-5 bg-white">
        <div className="flex justify-between p-5">
          <p className="title Update Tag">Tags</p>
          <div className="flex gap-3">
            <button
              className="btn-primary !px-4 flex items-center gap-2"
              onClick={() => setIsAddEditTagModalOpen(true)}
            >
              <Add />
              <span>Add Tag</span>
            </button>
          </div>
        </div>

        <SkeletonTable
          columns={columns}
          searchingFields={["name"]}
          data={tags}
          isLoading={isLoading}
        />
      </div>

      {/* Add Tags */}
      <ModalComponent
        isOpen={isAddEditTagModalOpen}
        setIsOpen={setIsAddEditTagModalOpen}
        width={500}
      >
        <p className="title text-center mb-4">
          {!isEditTag ? "Add Tag" : "Update Tag"}
        </p>
        <Form
          autoComplete="off"
          layout="vertical"
          form={form}
          initialValues={initialTagValues}
          onFinish={handleAddEditTag}
        >
          <Form.Item
            name="name"
            label="Tag Name"
            className="mb-0"
            rules={[{ required: true, message: "Please enter tag name!" }]}
          >
            <Input placeholder="Enter tag name" size="large" />
          </Form.Item>

          <div className="text-center mt-5">
            <LoadableButton
              type="submit"
              lable="Submit"
              loadingLable={!isEditTag ? "Adding Tag..." : "Updating Tag..."}
              isLoading={isAddEditTagLoading}
            />
          </div>
        </Form>
      </ModalComponent>

      {/* ------ Confirmation modal for status ------- */}
      <ConfirmationModal
        isOpen={isStatusModalOpen}
        setIsOpen={setIsStatusModalOpen}
        message="Are you sure, you want to change tag status?"
        onConfirm={handleStatuChange}
        isLoading={isStatusLoading}
        loadingLabel="Changing status..."
      />

      {/* Delete tag */}
      <ConfirmationModal
        isOpen={isTagDelete}
        setIsOpen={setIsTagDelete}
        message="Are you sure, want to delete this tag?"
        onConfirm={() => handleDeleteTag()}
        isLoading={isLoadingDelete}
        loadingLabel="Removing tag..."
      />
    </div>
  );
}
